import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import { COLORS, TYPO, CARD_PAD } from "../../styles/uiConstants";

/**
 * Kompakt bilgi satırı: sol tarafta label, sağ tarafta içerik.
 * Settings/detail sayfaları için.
 * @param {string} label
 * @param {boolean} [noBorder=false]
 * @param {React.ReactNode} children
 */
export default function InfoRow({ label, children, noBorder = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        py: 1.5,
        px: CARD_PAD,
        borderBottom: noBorder ? "none" : `1px solid ${COLORS.slate100}`,
        minHeight: 44,
        "&:hover": { bgcolor: alpha(COLORS.slate50, 0.5) },
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: COLORS.slate500,
          fontWeight: 600,
          fontSize: TYPO.label,
          minWidth: 110,
          pt: 0.6,
          flexShrink: 0,
        }}
      >
        {label}
      </Typography>
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
